/* TORTIS storefront behaviour — ported from the Lovable React build. No dependencies. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Reveal (fade-up on scroll) ---------- */
  function initReveal() {
    var els = $$("[data-reveal]");
    if (!("IntersectionObserver" in window) || reduced) { els.forEach(function (el) { el.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, d = parseInt(el.getAttribute("data-delay") || "0", 10);
        setTimeout(function () { el.classList.add("in"); }, d);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -10% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- In-view effects: bars, count-ups, staggered lab rows ---------- */
  function onceInView(el, threshold, cb) {
    if (!("IntersectionObserver" in window)) return cb();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } });
    }, { threshold: threshold, rootMargin: "0px 0px -10% 0px" });
    io.observe(el);
  }
  function initInView() {
    $$("[data-inview]").forEach(function (el) {
      onceInView(el, 0.3, function () {
        $$("[data-bar]", el).forEach(function (b) { b.style.width = b.getAttribute("data-bar") + "%"; });
        $$("[data-stagger]", el).forEach(function (r) { r.style.opacity = "1"; r.style.translate = "0 0"; });
      });
    });
    $$("[data-count]").forEach(function (el) {
      var to = parseFloat(el.getAttribute("data-count")), dec = parseInt(el.getAttribute("data-decimals") || "0", 10), suf = el.getAttribute("data-suffix") || "";
      onceInView(el, 0.4, function () {
        if (reduced) { el.textContent = to.toFixed(dec) + suf; return; }
        var t0 = performance.now(), dur = 1400;
        (function tick(now) {
          var p = Math.min(1, (now - t0) / dur), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (to * eased).toFixed(dec) + suf;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    });
  }

  /* ---------- Nav: compact on scroll, mobile menu ---------- */
  function initNav() {
    var nav = $("#tortis-nav");
    if (nav) {
      var update = function () { nav.classList.toggle("is-compact", window.scrollY > 80); };
      update();
      window.addEventListener("scroll", update, { passive: true });
    }
    var menu = $("#mobile-menu"), toggle = $("[data-menu-toggle]");
    if (!menu || !toggle) return;
    var open = function (v) {
      menu.classList.toggle("hidden", !v); menu.classList.toggle("flex", v);
      document.documentElement.classList.toggle("menu-open", v);
      document.body.style.overflow = v ? "hidden" : "";
      toggle.setAttribute("aria-expanded", v ? "true" : "false");
    };
    toggle.addEventListener("click", function () { open(true); });
    $$("[data-menu-close]", menu).forEach(function (b) { b.addEventListener("click", function () { open(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") open(false); });
  }

  /* ---------- Sticky CTA: show once the trigger (hero / buy box) scrolls away ---------- */
  function initSticky() {
    var bar = $("#sticky-cta"), trigger = $("[data-sticky-trigger]") || $("#shop");
    if (!bar || !trigger || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle("is-visible", visible);
      bar.setAttribute("aria-hidden", visible ? "false" : "true");
      $$("a", bar).forEach(function (a) { a.tabIndex = visible ? 0 : -1; });
    }, { threshold: 0 }).observe(trigger);
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    $$("[data-gallery]").forEach(function (g) {
      var imgs = $$("[data-gallery-img]", g), thumbs = $$("[data-gallery-thumb]", g), active = 0;
      var go = function (i) {
        active = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle("opacity-100", k === active); im.classList.toggle("opacity-0", k !== active); });
        thumbs.forEach(function (t, k) { t.classList.toggle("border-[#1E3520]", k === active); t.classList.toggle("border-transparent", k !== active); });
      };
      var prev = $("[data-gallery-prev]", g), next = $("[data-gallery-next]", g);
      if (prev) prev.addEventListener("click", function () { go(active - 1); });
      if (next) next.addEventListener("click", function () { go(active + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { go(k); }); });
    });
  }

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = (window.TORTIS && window.TORTIS.moneyFormat) || "${{amount}}";
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_no_decimals") return Math.round(cents / 100).toString();
      if (k === "amount_with_comma_separator") return v.replace(".", ",");
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null,
    open: function () {
      document.documentElement.classList.add("cart-open");
      Cart.el.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      var c = $("[data-cart-close]", Cart.el); if (c) setTimeout(function () { c.focus(); }, 50);
    },
    close: function () {
      document.documentElement.classList.remove("cart-open");
      Cart.el.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    },
    fetch: function () { return fetch(window.TORTIS.routes.cart, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); },
    change: function (key, qty) {
      return fetch(window.TORTIS.routes.cartChange, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(Cart.render);
    },
    render: function (cart) {
      var count = $$("[data-cart-count]");
      count.forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle("hidden", cart.item_count === 0); });
      if (!Cart.el) return;
      var items = $("[data-cart-items]", Cart.el), sub = $("[data-cart-subtotal]", Cart.el), ship = $("[data-cart-ship]", Cart.el), btn = $("[data-cart-checkout]", Cart.el);
      sub.textContent = money(cart.total_price);
      btn.disabled = cart.item_count === 0;
      var pouches = 0;
      cart.items.forEach(function (it) { var m = /(\d+)\s*Pouch/i.exec(it.variant_title || ""); pouches += (m ? parseInt(m[1], 10) : 1) * it.quantity; });
      if (cart.item_count === 0) ship.innerHTML = "";
      else if (pouches >= 2) ship.innerHTML = '<p class="rounded-lg bg-[#2C4A38] px-4 py-2.5 text-center text-[11px] uppercase tracking-[0.09em] text-[#EFEAE1]">You\'ve unlocked free shipping</p>';
      else ship.innerHTML = '<p class="rounded-lg bg-[#DCE3D6] px-4 py-2.5 text-center text-[11px] uppercase tracking-[0.09em] text-[#2C4A38]">Add one more pouch for free shipping</p>';
      if (cart.item_count === 0) {
        items.innerHTML = '<div class="py-16 text-center"><p class="font-serif text-[22px]">Your cart is empty.</p><a href="/products/creatine-ritual-gum" class="mt-6 inline-flex rounded-xl bg-[#3D4A3A] px-8 py-4 text-[11px] uppercase tracking-[0.22em] text-[#F3EEE5]">Shop Mint No. 01 →</a></div>';
        return;
      }
      items.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
        var compare = it.original_line_price > it.final_line_price ? '<span class="block text-[11px] text-[#9A9488] line-through">' + money(it.original_line_price) + "</span>" : "";
        return '<div class="flex gap-4 border-b py-4" style="border-color:rgba(61,74,58,0.12)">' +
          (img ? '<img src="' + img + '" alt="" class="h-20 w-20 shrink-0 rounded-lg bg-[#F9F7EA] object-cover">' : "") +
          '<div class="min-w-0 flex-1"><p class="font-serif text-[17px] leading-snug">' + escapeHtml(it.product_title) + "</p>" +
          '<p class="text-[12px]" style="color:rgba(61,74,58,0.65)">' + escapeHtml(it.variant_title || "") + "</p>" +
          '<div class="mt-2 flex items-center gap-3"><div class="inline-flex items-center rounded-lg border" style="border-color:rgba(61,74,58,0.25)">' +
          '<button type="button" class="px-3 py-1.5 text-[15px]" data-qty="' + it.key + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<span class="min-w-[24px] text-center text-[13px]">' + it.quantity + "</span>" +
          '<button type="button" class="px-3 py-1.5 text-[15px]" data-qty="' + it.key + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="text-[11px] uppercase tracking-[0.16em] underline" style="color:rgba(61,74,58,0.6)" data-qty="' + it.key + '" data-to="0">Remove</button></div></div>' +
          '<div class="text-right"><span class="text-[15px] font-medium">' + money(it.final_line_price) + "</span>" + compare + "</div></div>";
      }).join("");
    },
    init: function () {
      Cart.el = $("#cart-drawer");
      if (!Cart.el) return;
      $$("[data-cart-open]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); Cart.fetch().then(Cart.render); Cart.open(); }); });
      $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", Cart.close); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && document.documentElement.classList.contains("cart-open")) Cart.close(); });
      Cart.el.addEventListener("click", function (e) {
        var b = e.target.closest("[data-qty]"); if (!b) return;
        b.disabled = true; Cart.change(b.getAttribute("data-qty"), parseInt(b.getAttribute("data-to"), 10));
      });
    }
  };
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---------- Buy box: pack selection + AJAX add to cart ---------- */
  var PACK_KEY = "tortis-selected-pack";
  function initBuybox() {
    // "Shop 3 Pouches" style links preselect a pack for the product page.
    $$("[data-select-pack], [data-pack-link]").forEach(function (a) {
      a.addEventListener("click", function () {
        var i = a.getAttribute("data-select-pack"); if (i == null) i = String(parseInt(a.getAttribute("data-pack-link"), 10) - 1);
        store.set(PACK_KEY, i);
      });
    });
    $$("[data-buybox]").forEach(function (box) {
      var radios = $$('input[type="radio"][name="id"]', box), imgs = $$("[data-pack-img]", box);
      var show = function (i) {
        imgs.forEach(function (im) {
          var on = im.getAttribute("data-pack-img") === String(i);
          im.classList.toggle("opacity-100", on); im.classList.toggle("opacity-0", !on); im.classList.toggle("pointer-events-none", !on);
          if (on) im.removeAttribute("aria-hidden"); else im.setAttribute("aria-hidden", "true");
        });
      };
      var hasVariantParam = /[?&]variant=/.test(window.location.search);
      var saved = store.get(PACK_KEY);
      if (!hasVariantParam && saved != null) {
        var r = radios.filter(function (x) { return x.getAttribute("data-index") === saved && !x.disabled; })[0];
        if (r) { r.checked = true; show(saved); }
      }
      radios.forEach(function (r) {
        r.addEventListener("change", function () { var i = r.getAttribute("data-index"); show(i); store.set(PACK_KEY, i); });
      });
      var form = $("form[data-product-form]", box) || box.querySelector("form");
      if (!form) return;
      form.addEventListener("submit", function (e) {
        if (!window.fetch || !Cart.el) return; // fall back to normal /cart/add
        e.preventDefault();
        var btn = $("[data-add-to-cart]", form), label = $("[data-atc-label]", form), err = $("[data-atc-error]", form);
        var sel = radios.filter(function (x) { return x.checked; })[0];
        if (!sel) return;
        btn.classList.add("btn-loading"); label.textContent = "Adding…"; err.classList.add("hidden");
        fetch(window.TORTIS.routes.cartAdd, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart"); return j; }); })
          .then(function () { return Cart.fetch(); })
          .then(function (cart) { Cart.render(cart); Cart.open(); label.textContent = "Added"; setTimeout(function () { label.textContent = "Add to cart"; }, 1600); })
          .catch(function (x) { err.textContent = x.message; err.classList.remove("hidden"); label.textContent = "Add to cart"; })
          .then(function () { btn.classList.remove("btn-loading"); });
      });
    });
  }

  /* ---------- Hare vs tortoise graph ---------- */
  function initFable() {
    $$("[data-fable]").forEach(function (sec) {
      var svg = $("[data-fable-svg]", sec), hare = $("[data-hare-path]", sec), tort = $("[data-tort-path]", sec);
      var hareG = $("[data-hare]", sec), tortG = $("[data-tort]", sec), cursor = $("[data-cursor]", sec), story = $("[data-fable-story]", sec);
      var hareLen = hare.getTotalLength(), tortLen = tort.getTotalLength(), HARE_END_X = 600;
      [[hare, hareLen], [tort, tortLen]].forEach(function (p) { p[0].style.strokeDasharray = p[1]; p[0].style.strokeDashoffset = p[1]; });
      var drawn = false, active = false, cursorX = null, autoX = 40, raf = 0, start = 0;
      var yAt = function (path, len, x) {
        var lo = 0, hi = len;
        for (var i = 0; i < 22; i++) { var mid = (lo + hi) / 2; if (path.getPointAtLength(mid).x < x) lo = mid; else hi = mid; }
        return path.getPointAtLength((lo + hi) / 2).y;
      };
      var storyFor = function () {
        if (!active || cursorX == null || cursorX < 130) return "They start together.";
        if (cursorX < 420) return "The hare loads everything at once.";
        if (cursorX < 660) return "And by week three — gone.";
        if (cursorX < 880) return "The tortoise never stopped.";
        return "Still here. Built permanent.";
      };
      var draw = function () {
        if (!drawn) return;
        var x = active && cursorX != null ? cursorX : autoX;
        var hareVisible = x <= HARE_END_X - 6;
        if (hareVisible) {
          hareG.style.display = ""; hareG.setAttribute("transform", "translate(" + x + "," + (yAt(hare, hareLen, x) - 11) + ")");
          hareG.style.opacity = Math.max(0, Math.min(1, (HARE_END_X - 6 - x) / 60));
        } else hareG.style.display = "none";
        tortG.style.display = ""; tortG.setAttribute("transform", "translate(" + x + "," + (yAt(tort, tortLen, x) - 9) + ")");
        if (active && cursorX != null) { cursor.style.display = ""; cursor.setAttribute("x1", cursorX); cursor.setAttribute("x2", cursorX); } else cursor.style.display = "none";
        var s = storyFor(); if (story.textContent !== s) story.textContent = s;
      };
      var loop = function (t) {
        if (!start) start = t;
        autoX = 40 + (((t - start) % 9000) / 9000) * (980 - 40);
        draw();
        raf = requestAnimationFrame(loop);
      };
      var startLoop = function () { if (!raf && !reduced) { start = 0; raf = requestAnimationFrame(loop); } };
      var stopLoop = function () { cancelAnimationFrame(raf); raf = 0; };
      onceInView(sec, 0.25, function () {
        drawn = true;
        hare.style.strokeDashoffset = 0; tort.style.strokeDashoffset = 0;
        $("[data-hare-area]", sec).setAttribute("opacity", "1"); $("[data-tort-area]", sec).setAttribute("opacity", "1");
        if (reduced) { autoX = 980; draw(); } else startLoop();
      });
      var move = function (clientX) {
        var rect = svg.getBoundingClientRect(), rel = (clientX - rect.left) / rect.width;
        cursorX = Math.max(40, Math.min(980, 40 + rel * (980 - 40)));
        active = true; stopLoop(); draw();
      };
      var leave = function () { cursorX = null; active = false; draw(); startLoop(); };
      svg.addEventListener("mousemove", function (e) { move(e.clientX); });
      svg.addEventListener("mouseleave", leave);
      svg.addEventListener("touchstart", function (e) { move(e.touches[0].clientX); }, { passive: true });
      svg.addEventListener("touchmove", function (e) { move(e.touches[0].clientX); }, { passive: true });
      svg.addEventListener("touchend", leave);
    });
  }

  /* ---------- Maintenance dose diagram ---------- */
  function initDose() {
    $$("[data-dose]").forEach(function (sec) {
      var levels = sec.getAttribute("data-levels").split(",").map(Number), gaps = sec.getAttribute("data-gaps").split(",").map(Number);
      var steps = $$("[data-dose-step]", sec), fills = $$("[data-dose-fill]", sec), gapEls = $$("[data-dose-gap]", sec), rail = $("[data-dose-rail]", sec);
      var active = 0, hover = null, paused = false, timer = 0, resume = 0;
      var paint = function () {
        var shown = hover != null ? hover : active;
        fills.forEach(function (f) { f.style.height = levels[shown] + "%"; });
        gapEls.forEach(function (g) { g.style.opacity = gaps[shown] ? "0.5" : "0"; });
        rail.style.height = (active / (steps.length - 1)) * 100 + "%";
        steps.forEach(function (s, i) { s.setAttribute("aria-pressed", i === active ? "true" : "false"); });
      };
      var tick = function () { if (!paused) { active = (active + 1) % steps.length; paint(); } };
      if (!reduced) timer = setInterval(tick, 2600);
      sec.addEventListener("mouseenter", function () { clearTimeout(resume); paused = true; });
      sec.addEventListener("mouseleave", function () { clearTimeout(resume); hover = null; paint(); resume = setTimeout(function () { paused = false; }, 900); });
      steps.forEach(function (s, i) {
        s.addEventListener("click", function () { active = i; clearTimeout(resume); paused = true; resume = setTimeout(function () { paused = false; }, 5000); paint(); });
        s.addEventListener("mouseenter", function () { hover = i; paint(); });
        s.addEventListener("mouseleave", function () { hover = null; paint(); });
        s.addEventListener("focus", function () { hover = i; paint(); });
        s.addEventListener("blur", function () { hover = null; paint(); });
      });
      paint();
    });
  }

  /* ---------- Founding offer modal (once per session) ---------- */
  function initModal() {
    var m = $("#founding-modal"); if (!m || store.get("tortis-modal-seen")) return;
    var dialog = $('[role="dialog"]', m), prevFocus = null, scrollY = 0, fired = false, isOpen = false;
    var onKey = function (e) {
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var nodes = $$('a[href], button:not([disabled])', dialog); if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    var open = function () {
      if (fired || document.documentElement.classList.contains("cart-open")) return;
      fired = true; isOpen = true; store.set("tortis-modal-seen", "1");
      prevFocus = document.activeElement; scrollY = window.scrollY;
      var b = document.body; b.style.position = "fixed"; b.style.top = -scrollY + "px"; b.style.width = "100%"; b.style.overflow = "hidden";
      m.classList.remove("hidden"); m.classList.add("flex");
      document.addEventListener("keydown", onKey);
      setTimeout(function () { var f = $("a[href], button", dialog); if (f) f.focus(); }, 60);
    };
    var close = function () {
      if (!isOpen) return; isOpen = false;
      m.classList.add("hidden"); m.classList.remove("flex");
      document.removeEventListener("keydown", onKey);
      var b = document.body; b.style.position = ""; b.style.top = ""; b.style.width = ""; b.style.overflow = "";
      var html = document.documentElement, prevSB = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto"; window.scrollTo(0, scrollY); html.style.scrollBehavior = prevSB;
      if (prevFocus && prevFocus.focus) prevFocus.focus();
    };
    m.addEventListener("click", function (e) { if (e.target === m) close(); });
    $$("[data-modal-close]", m).forEach(function (b) { b.addEventListener("click", close); });
    setTimeout(open, 6000);
    if (window.matchMedia("(min-width: 768px)").matches) document.addEventListener("mouseout", function (e) { if (e.clientY <= 0 && !e.relatedTarget) open(); });
  }

  function init() {
    initReveal(); initInView(); initNav(); initSticky(); initGallery();
    Cart.init(); initBuybox(); initFable(); initDose(); initModal();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
